import {Component, OnInit, ChangeDetectorRef, ViewEncapsulation} from '@angular/core';
import { MapService } from '../../services/map.service';
import { UserService } from '../../services/user.service';
import { PopupService } from '../../services/popup.service';
import { FeatureService } from '../../services/feature.service';

@Component({
  selector: 'app-user-map',
  templateUrl: './user-map.component.html',
  styleUrls: ['./user-map.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class UserMapComponent implements OnInit {

  constructor(public mapService: MapService, public userService: UserService, public ref: ChangeDetectorRef, public popupService: PopupService, public featureService: FeatureService) { }

  ngOnInit() {
  }

  restore() {
    this.userService.restoreCurrentUserMap();
    this.ref.detectChanges();
  }

  openSaveMapSignUpPrompt() {
    let w = (<any>window);
    w.saveMap.updateMapData();
    let newUserMap = {
      name: this.mapService.currentUserMap.name,
      mapData: []
    };
    newUserMap.mapData = w.saveMap.convertMapDataToKeyValue();
    this.featureService.updateFeature('save-map');
    this.featureService.updateExecutionFeature('save-map', newUserMap);
    this.popupService.updateRoute('sign-up');
  }
}



// WEBPACK FOOTER //
// ./src/app/components/user-map/user-map.component.ts